import { find, map } from "lodash-es";
import { IServiceDataItem } from "../components/common/FeatureSlider/FeatureSlider";
import { AllInteractions } from "../models/homepage";
import CaIcon1x from "../assets/image/ca_1x.webp";
import CaIcon2x from "../assets/image/ca_2x.webp";
import CaIcon3x from "../assets/image/ca_3x.webp";
import OnmoIcon1x from "../assets/image/onmo_1x.webp";
import OnmoIcon2x from "../assets/image/onmo_2x.webp";
import OnmoIcon3x from "../assets/image/onmo_3x.webp";
import PlayIncIcon1x from "../assets/image/playinc_1x.webp";
import PlayIncIcon2x from "../assets/image/playinc_2x.webp";
import PlayIncIcon3x from "../assets/image/playinc_3x.webp";
import FanclashIcon1x from "../assets/image/fanclash_1x.webp";
import FanclashIcon2x from "../assets/image/fanclash_2x.webp";
import FanclashIcon3x from "../assets/image/fanclash_3x.webp";
import FcIcon1x from "../assets/esports/fc_icon_1x.webp";
import FcIcon2x from "../assets/esports/fc_icon_2x.webp";
import FcIcon3x from "../assets/esports/fc_icon_3x.webp";
import Sf5Icon1x from "../assets/esports/sf5_icon_1x.webp";
import Sf5Icon2x from "../assets/esports/sf5_icon_2x.webp";
import Sf5Icon3x from "../assets/esports/sf5_icon_3x.webp";
import FortniteIcon1x from "../assets/esports/fortnite_icon_1x.webp";
import FortniteIcon2x from "../assets/esports/fortnite_icon_2x.webp";
import FortniteIcon3x from "../assets/esports/fortnite_icon_3x.webp";
import CodIcon1x from "../assets/esports/cod_icon_1x.webp";
import CodIcon2x from "../assets/esports/cod_icon_2x.webp";
import CodIcon3x from "../assets/esports/cod_icon_3x.webp";
import PubgIcon1x from "../assets/esports/pubg_icon_1x.webp";
import PubgIcon2x from "../assets/esports/pubg_icon_2x.webp";
import PubgIcon3x from "../assets/esports/pubg_icon_3x.webp";

export type LaunchpadId = "ca" | "onmo" | "playinc" | "fanclash";
export type IconSet = {
  src1x: string;
  src2x: string;
  src3x: string;
};

export const LAUNCHPAD_ICON: Record<LaunchpadId, IconSet> = {
  ca: {
    src1x: CaIcon1x,
    src2x: CaIcon2x,
    src3x: CaIcon3x,
  },
  onmo: {
    src1x: OnmoIcon1x,
    src2x: OnmoIcon2x,
    src3x: OnmoIcon3x,
  },
  playinc: {
    src1x: PlayIncIcon1x,
    src2x: PlayIncIcon2x,
    src3x: PlayIncIcon3x,
  },
  fanclash: {
    src1x: FanclashIcon1x,
    src2x: FanclashIcon2x,
    src3x: FanclashIcon3x,
  },
} as const;

export const defaultServiceIcon = [
  {
    title: "My Subscriptions",
    id: "mySubscriptions",
    launchpads: ["ca"],
  },
  {
    title: "Free Games",
    id: "freeGames",
    launchpads: [],
  },
  {
    title: "Casual Games",
    id: "casualGames",
    launchpads: ["playinc"],
  },
  {
    title: "Trivia Games",
    id: "triviaGames",
    launchpads: ["ca", "onmo"],
  },
  {
    title: "eSports",
    id: "eSports",
    launchpads: ["fanclash"],
  },
];

export const defaultServicesList = [
  {
    id: "mySubscriptions",
    title: "My Subscriptions",
    itemType: "vertical",
    enterLink: ["https://challengesarena.com/"],
    description: "Welcome back to Gamehub!",
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/My-Subcription.png",
    sliderItems: [],
  },
  {
    id: "freeGames",
    title: "Free Games",
    itemType: "vertical",
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/Free-Games.png",
    disableIframe: true,
    sliderItems: [
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Galaxy-Shooters.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/video/Galaxy-Shooters.mp4",
        link: "https://cms.onmostealth.com/games/129/ca?version=ca_1756277041567.js",
        disableIframe: true,
      },
      // {
      //   image:
      //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Basketball.png",
      //   video:
      //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/video/Basketball.mp4",
      //   link: "",
      //   disableIframe: true,
      // },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Little-Pond.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/video/Little-Pond.mp4",
        link: "https://cms.onmostealth.com/games/126/ca?version=ca_1752207898828.js",
        disableIframe: true,
      },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Fruit-Ninja.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/video/Fruit-Ninja.mp4",
        link: "https://cms.onmostealth.com/games/127/ca?version=ca_1755680041434.js",
        disableIframe: true,
      },
      // {
      //   image:
      //     "https://assets.onmostealth.com/static/gaming-platform/Free-Games/Penalty-Shootout-Masters.png",
      //     video:
      // "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/video/Penality-Shooter.mp4",
      //   link: "",
      //   disableIframe: true,
      // },
      {
        image:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/Viral-Tap.png",
        video:
          "https://assets.onmostealth.com/static/gaming-platform/Vodacom/free-games/video/Viral-Tap.mp4",
        link: "https://cms.onmostealth.com/games/128/ca?version=ca_1755167799739.js",
        disableIframe: true,
      },
    ],
  },
  {
    id: "casualGames",
    title: "Casual Games",
    itemType: "vertical",
    enterLink: ["https://playinc.com/"],
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/Casual-Games.png",
    sliderItems: [],
  },
  {
    id: "triviaGames",
    title: "Trivia Games",
    itemType: "vertical",
    enterLink: ["https://challengesarena.com/", "https://play.onmo.com/"],
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/Trival-Game.png",
    sliderItems: [],
  },
  {
    id: "eSports",
    title: "eSports",
    itemType: "vertical",
    enterLink: ["https://chessmasters.co.za/"],
    primaryColor: "#EB2553",
    display: "tab",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/eSport-game.png",
    sliderItems: [],
  },
];

const listGame = [
  {
    title: "Fruit Merge",
    partner: ["onmo"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/ONMO/Subway-Surfers.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/video/Subway-Surfers.mp4",
    link: "https://gamegoza.com/game/152144",
    isActive: true,
  },
  {
    title: "Cut the Rope",
    partner: ["onmo"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/Cut-The-Rope-Magic.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/video/Cut-The-Rope.mp4",
    link: "https://gamegoza.com/game/141753",
    isActive: true,
  },
  {
    title: "Hitman Sniper",
    partner: ["onmo"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/Hitman-Sniper.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/video/Hitman-Sniper.mp4",
    link: "https://gamegoza.com/game/13497",
    isActive: true,
  },
  {
    title: "Lara Croft",
    partner: ["onmo"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/Lara-Croft-Relic-Run.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/video/LaraCroft-RelicRun.mp4",
    link: "https://gamegoza.com/game/13392",
    isActive: true,
  },
  {
    title: "Gravity Rider",
    partner: ["onmo"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/Gravity-Rider.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/video/Gravity-Raider.mp4",
    link: "https://gamegoza.com/game/13454",
    isActive: true,
  },
  {
    title: "Archery",
    partner: ["ca"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/Archery.webp",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/video/Archery.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/2337938",
    isActive: true,
  },
  {
    title: "Color Sort Mania",
    partner: ["ca"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/Color-Sort-Mania.webp",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/video/Color-Sort-Mania.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/1380616",
    isActive: true,
  },
  {
    title: "Cricket Bash",
    partner: ["ca"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/Cricket-Bash.webp",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/video/Cricket-Bash.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/2337934",
    isActive: true,
  },
  {
    title: "Fruit-Merge",
    partner: ["ca"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/Fruit-Merge.webp",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/video/Fruit-Merge.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/1728762",
    isActive: true,
  },
  {
    title: "Solitiare PRO",
    partner: ["ca"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/Solitiare-PRO.webp",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/ca/video/Solitaire.mp4",
    link: "https://challengesarena.com/demo/home/battle-listing/1380612",
    isActive: true,
  },
  {
    title: "Chess Masters",
    partner: ["fanclash"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/fanclash/chess.webp",
    link: "https://unlock3.co.za/",
    isActive: true,
  },
  {
    title: "Quizinc 2.0",
    partner: ["fanclash"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/fanclash/quiz-head.png",
    link: "https://quizinc.co.za/",
    isActive: true,
  },
  {
    title: "Quiz",
    partner: ["fanclash"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/fanclash/quiz.jpeg",
    link: "https://quizhead2head.co.za/",
    isActive: true,
  },
  {
    title: "Stop The Clock",
    partner: ["fanclash"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/fanclash/stop-clock.png",
    link: "https://stopclock.co.za/",
    isActive: true,
  },
  {
    title: "TapKO",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/tap%20ok.webp",
    link: "https://playinc.com/games/details/TapKO/133812289",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Fish out of water",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/fish%20water.webp",
    link: "https://playinc.com/games/details/Fish-Out-Of-Water/133150012",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Ludo Legend",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/ludo%20legend.webp",
    link: "https://playinc.com/games/details/Ludo-Legend/59819350",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Basketball Master",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/basketball.webp",
    link: "https://playinc.com/games/details/Basketball-Master/58999566",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Coffee Break",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/coffee%20break.webp",
    link: "https://playinc.com/games/details/Coffee-Break-Puzzle/122638352",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Tower Boxer",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/tower%20boxer.webp",
    link: "https://playinc.com/games/details/Tower-Boxer/117796603",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Thor Boss",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/thor.webp",
    link: "https://playinc.com/games/details/Thor-Boss-Battles/94683541",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Color Pin",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/color%20pin.webp",
    link: "https://playinc.com/games/details/Knife-Madness/134053822",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Knife Madness",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/knife%20madness.webp",
    link: "https://playinc.com/games/details/Knife-Madness/134053822",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Garden Block",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/garden%20block.webp",
    link: "https://playinc.com/games/details/Garden-Block-Puzzle/133942955",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Pool Ball",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/pool.webp",
    link: "https://playinc.com/games/details/Pool-8-Ball-Mania/78565600",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Wood Block",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/wood%20block.webp",
    link: "https://playinc.com/games/details/Wood-Block-Puzzle/119117508",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Dots Mania",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/dotsmania.webp",
    link: "https://playinc.com/games/details/Dotsmania/39671867",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Disney Channel - House of haunts",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/disney%20channel.webp",
    link: "https://playinc.com/games/details/Disney-Channel-House-of-Haunts/114242606",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "7x7",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/7x7.webp",
    link: "https://playinc.com/games/details/7x7-Ultimate/49484032",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Halloween Match",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/halloween%20match%203.webp",
    link: "https://playinc.com/games/details/Halloween-Match-3/122675582",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Ben 10",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/ben%2010.webp",
    link: "https://playinc.com/games/details/Ben-10-Power-of-the-Omnitrix/67694219",
    isActive: true,
    disableIframe: true,
  },

  {
    title: "Help the duck",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/help%20duck.webp",
    link: "https://playinc.com/games/details/Help-The-Duck/129374840",
    isActive: true,
    disableIframe: true,
  },
  {
    title: "Jumpers quest",
    partner: ["playInc"],
    image:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/playinc/jumpers%20quest.webp",
    link: "https://playinc.com/games/details/Jumpers-Quest/133812290",
    isActive: true,
    disableIframe: true,
  },
];

const dataFeatureHomePage =
  // JSON.parse(import.meta.env.VITE_FEATURED_HOMEPAGE_CFG || "null") ||
  defaultServicesList;

export const servicesList = map(defaultServiceIcon, (serviceIcon) => {
  const serviceItem = find(dataFeatureHomePage, {
    title: serviceIcon.title,
  }) as IServiceDataItem;

  const sliderItems = listGame
    .filter((g) => g.isActive === true)
    .filter((g) =>
      g.partner.some((p) => serviceIcon.launchpads.includes(p.toLowerCase())),
    )
    .map((g) => ({
      image: g.image,
      video: g.video,
      link: g.link,
      partner: g.partner,
      disableIframe: g.disableIframe ?? false,
    }));

  return {
    ...serviceIcon,
    ...serviceItem,
    sliderItems: sliderItems.length ? sliderItems : serviceItem?.sliderItems,
  };
});

export const getLinkByServiceId = (
  serviceData: IServiceDataItem,
  selectedService: string,
) => {
  if (!selectedService) return serviceData.enterLink?.[0];
  if (selectedService) {
    const index = serviceData?.launchpads?.indexOf(selectedService) ?? 0;
    return index !== -1 ? serviceData?.enterLink?.[index] : undefined;
  }
};

export const MOCK_SERVICE_INTERACTIONS: Readonly<AllInteractions> = {
  ca: { isFavorited: false, dateFavorited: null },
  onmo: { isFavorited: false, dateFavorited: null },
  blacknut: { isFavorited: false, dateFavorited: null },
  poki: { isFavorited: false, dateFavorited: null },
  video: { isFavorited: false, dateFavorited: null },
  news: { isFavorited: false, dateFavorited: null },
  esports: { isFavorited: false, dateFavorited: null },
  vouchers: { isFavorited: false, dateFavorited: null },
};

export interface IHomeFeedItem {
  id: string;
  title: string;
  type: "FREE_GAME" | "PAID_GAME" | "CUSTOM_PAGE";
  background: string;
  icon: string;
  link: string;
  video: string;
  category: "ca" | "onmo" | "playinc" | "fanclash";
  isSubscribed?: boolean;
}

export const HOME_FEED = [
  // 1 - 7
  {
    id: "1",
    title: "Galaxy Shooters",
    type: "FREE_GAME",
    category: "ca",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Galaxy-Shooters.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Galaxy-Shooters.png",
    link: "/play/114",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Galaxy-Shooter.mp4",
  },
  {
    id: "2",
    title: "Vital Hit",
    type: "FREE_GAME",
    category: "",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Virus+Hit.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Virus-Hit.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Viral-Hit.mp4",
    link: "/play/110",
    isSubscribed: false,
  },
  {
    id: "3",
    title: "Fruit Ninja Slice",
    type: "FREE_GAME",
    category: "",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Fruit-Ninja-Slice.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Fruit-Ninja-Slice.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Fruit-Ninja-Slice.mp4",
    link: "/play/109",
    isSubscribed: false,
  },
  {
    id: "4",
    title: "Pond Match",
    type: "FREE_GAME",
    category: "",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Pond-Match.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Pond-Match.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Pond-Match.mp4",
    link: "/play/115",
    isSubscribed: false,
  },
  // {
  //   id: "5",
  //   title: "Penalty Shootout Masters",
  //   type: "FREE_GAME",
  //   category: "",
  //   background:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Penalty-Shootout-Masters.png",
  //   icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Penalty-Shootout-Masters.png",
  //   video:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Penalty-Shootout-Masters.mp4",
  //   link: "/play/116",
  //   isSubscribed: false,
  // },
  // {
  //   id: "6",
  //   title: "Mini Hoops",
  //   type: "FREE_GAME",
  //   category: "",
  //   background:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Mini-Hoops.png",
  //   icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Mini-Hoops.png",
  //   video:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Mini-Hoops.mp4",
  //   link: "/play/",
  //   isSubscribed: false,
  // },
  // {
  //   id: "7",
  //   title: "Shape Smashers",
  //   type: "FREE_GAME",
  //   category: "",
  //   background:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Shape-Smashers.png",
  //   icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Shape-Smashers.png",
  //   video:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Shape-Smashers.mp4",
  //   link: "/play/",
  //   isSubscribed: false,
  // },

  //10 - 30 - 35 -41
  {
    id: "10",
    title: "TapKO",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/TapKO.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/TapKO.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/TapKO.mp4",
    link: "https://playinc.com/games/details/TapKO/133812289",
    isSubscribed: false,
  },
  {
    id: "30",
    title: "Unlock 3",
    type: "PAID_GAME",
    category: "unlock3",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Unlock-3.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Unlock-3.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Unlock-3.mp4",
    link: "https://gamezone.unlock3.co.za/",
    isSubscribed: false,
  },
  // {
  //   id: "35",
  //   title: "Subway Surfer",
  //   type: "PAID_GAME",
  //   category: "gamegoza",
  //   background:
  //     "https://assets.onmostealth.com/static/gaming-platform/ONMO/Subway-Surfers.png",
  //   icon: "",
  //   video:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/onmo/video/Subway-Surfers.mp4",
  //   link: "https://gamegozastg.onmogaming.com/game/152144",
  //   isSubscribed: false,
  // },
  {
    id: "41",
    title: "Solitaire",
    type: "PAID_GAME",
    category: "challengesarena",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Solitiare-Pro.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Solitiare-Pro.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Solitaire-Pro.mp4",
    link: "https://vcsaca.onmogaming.com/play/982",
    isSubscribed: false,
  },

  // 11 - 31 - 36 - 42
  {
    id: "11",
    title: "Fish out of water",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Fish-Out-Of-Water.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Fish-Out-Of-Water.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Fish-Out-Of-Water.mp4",
    link: "https://playinc.com/games/details/Fish-Out-Of-Water/133150012",
    isSubscribed: false,
  },
  {
    id: "31",
    title: "Quizinc 2.0",
    type: "PAID_GAME",
    category: "quizinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Quizinc-2.0.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Quizinc-2.0.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Quizinc.mp4",
    link: "https://gamezone.quizinc.co.za/",
    isSubscribed: false,
  },
  {
    id: "36",
    title: "Cut the Rope",
    type: "PAID_GAME",
    category: "gamegoza",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Cut-The-Rope-Magic.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Cut-The-Rope-Magic.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Cut-the-Rope-Experiments.mp4",
    link: "https://gamegozastg.onmogaming.com/play/casual/da949373-c61b-4732-ab64-008feb2a3cf6",
    isSubscribed: false,
  },
  {
    id: "42",
    title: "Carrom",
    type: "PAID_GAME",
    category: "challengesarena",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Quick-Carrom.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Quick-Carrom.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Quick-Carrom.mp4",
    link: "https://vcsaca.onmogaming.com/play/976",
    isSubscribed: false,
  },

  // 12 - 32 - 37 - 43
  {
    id: "12",
    title: "Ludo Legend",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Ludo-Legend.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Ludo-Legend.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Ludo-Legend.mp4",
    link: "https://playinc.com/games/details/Ludo-Legend/59819350",
    isSubscribed: false,
  },
  {
    id: "32",
    title: "Head2Head",
    type: "PAID_GAME",
    category: "quizhead2head",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Head2Head.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Head2Head.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Head2Head.mp4",
    link: "https://gamezone.quizhead2head.co.za/",
    isSubscribed: false,
  },
  {
    id: "37",
    title: "Hitman Sniper",
    type: "PAID_GAME",
    category: "gamegoza",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Hitman-Sniper.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Hitman-Sniper.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Hitman-Sniper.mp4",
    link: "https://gamegozastg.onmogaming.com/play/casual/af79aae5-7e6c-4a3f-a3ba-e297551590bc",
    isSubscribed: false,
  },
  {
    id: "43",
    title: "Cricket Bash",
    type: "PAID_GAME",
    category: "challengesarena",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Cricket-Bash.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Cricket-Bash.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Cricket-Bash.mp4",
    link: "https://vcsaca.onmogaming.com/play/975",
    isSubscribed: false,
  },

  // 13 - 33 - 38 - 44
  {
    id: "13",
    title: "Basketball Master",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Basketball-Master.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Basketball-Master.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Basketball-Master.mp4",
    link: "https://playinc.com/games/details/Basketball-Master/58999566",
    isSubscribed: false,
  },
  {
    id: "33",
    title: "Stop The Clock",
    type: "PAID_GAME",
    category: "stopclock",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Stop-The-Clock.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Stop-The-Clock.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Stop-The-Clock.mp4",
    link: "https://gamezone.stopclock.co.za/",
    isSubscribed: false,
  },
  {
    id: "38",
    title: "Lara Croft",
    type: "PAID_GAME",
    category: "gamegoza",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Lara-Croft-Go.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Lara-Croft-Go.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Lara-Croft-Go.mp4",
    link: "https://gamegozastg.onmogaming.com/play/casual/a3ad513e-34a1-4317-bdd4-f31ae6ca6552",
    isSubscribed: false,
  },
  // miss image, video
  // {
  //   id: "44",
  //   title: "Bottle Shoot",
  //   type: "PAID_GAME",
  //   category: "challengesarena",
  //   background: "",
  //   icon: "",
  //   video: "",
  //   link: "https://vcsaca.onmogaming.com/play/1728762",
  //   isSubscribed: false,
  // },

  // 14 - 34 - 39 - 45
  {
    id: "14",
    title: "Coffee Break",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Coffee-Break-Puzzle.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Coffee-Break-Puzzle.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Coffee-Break-Puzzle.mp4",
    link: "https://playinc.com/games/details/Coffee-Break-Puzzle/122638352",
    isSubscribed: false,
  },
  {
    id: "15",
    title: "Tower Boxer",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Tower-Boxer.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Tower-Boxer.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Tower-Boxer.mp4",
    link: "https://playinc.com/games/details/Tower-Boxer/117796603",
    isSubscribed: false,
  },
  {
    id: "39",
    title: "Gravity Rider",
    type: "PAID_GAME",
    category: "gamegoza",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Gravity-Rider.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Gravity-Rider.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Gravity-Rider.mp4",
    link: "https://gamegozastg.onmogaming.com/play/casual/4bb17218-8a8e-4573-8508-57b21afc29cf",
    isSubscribed: false,
  },
  // miss image
  // no background, video
  // {
  //   id: "45",
  //   title: "Knife Smash",
  //   type: "PAID_GAME",
  //   category: "challengesarena",
  //   background: "",
  //   icon: "",
  //   video: "",
  //   link: "https://vcsaca.onmogaming.com/play/1380612",
  //   isSubscribed: false,
  // },

  // 16 - 29
  {
    id: "16",
    title: "Thor Boss",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Thor-Boss-Battles.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Thor-Boss-Battles.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Thor-Boss-Battles.mp4",
    link: "https://playinc.com/games/details/Thor-Boss-Battles/94683541",
    isSubscribed: false,
  },
  {
    id: "29",
    title: "Chess Masters",
    type: "PAID_GAME",
    category: "chessmasters",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Chess-Masters.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Chess-Masters.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Chess-Masters.mp4",
    link: "https://gamezone.chessmasters.co.za/",
    isSubscribed: false,
  },

  // 17 - 18 - 19 - 20 - 21- 22 - 23 - 24 - 25 - 26 - 27 - 28
  {
    id: "17",
    title: "Color Pin",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Color-Pin.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Color-Pin.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Color-Pin.mp4",
    link: "https://playinc.com/games/details/Color-Pin/44357742",
    isSubscribed: false,
  },
  {
    id: "18",
    title: "Knife Madness",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Knife-Madness.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Knife-Madness.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Knife-Madness.mp4",
    link: "https://playinc.com/games/details/Knife-Madness/134053822",
    isSubscribed: false,
  },
  {
    id: "19",
    title: "Garden Block",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Garden-Block-Puzzle.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Garden-Block-Puzzle--.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Garden-Block-Puzzle.mp4",
    link: "https://playinc.com/games/details/Garden-Block-Puzzle/133942955",
    isSubscribed: false,
  },
  {
    id: "20",
    title: "Pool Ball",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Pool-8-Ball-Mania.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Pool-8-Ball-Mania.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Pool-8-Ball-Mania.mp4",
    link: "https://playinc.com/games/details/Pool-8-Ball-Mania/78565600",
    isSubscribed: false,
  },
  {
    id: "21",
    title: "Wood Block",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Wood-Block-Puzzle.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Wood-Block-Puzzle.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Wood-Block-Puzzle.mp4",
    link: "https://playinc.com/games/details/Wood-Block-Puzzle/119117508",
    isSubscribed: false,
  },
  {
    id: "22",
    title: "Dots Mania",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Dotsmania.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Dotsmania.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Dots-Mania.mp4",
    link: "https://playinc.com/games/details/Dotsmania/39671867",
    isSubscribed: false,
  },
  {
    id: "23",
    title: "Disney Channel - House of haunts",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Disney-Channel-House-of-Haunts.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Disney-Channel-House-of-Haunts.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Disney-Channel-House-of-Haunts.mp4",
    link: "https://playinc.com/games/details/Disney-Channel-House-of-Haunts/114242606",
    isSubscribed: false,
  },
  {
    id: "24",
    title: "7x7",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/7x7-Ultimate.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/7x7-Ultimate.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/7x7-Ultimate.mp4",
    link: "https://playinc.com/games/details/7x7-Ultimate/49484032",
    isSubscribed: false,
  },
  {
    id: "25",
    title: "Halloween Match",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Halloween-Match-3.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Halloween-Match-3.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Halloween-Match-3.mp4",
    link: "https://playinc.com/games/details/Halloween-Match-3/122675582",
    isSubscribed: false,
  },
  {
    id: "26",
    title: "Ben 10",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Ben-10-Power-of-the-Omnitrix.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Ben-10-Power-of-the-Omnitrix.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Ben-10-Power-of-the-Omnitrix.mp4",
    link: "https://playinc.com/games/details/Ben-10-Power-of-the-Omnitrix/67694219",
    isSubscribed: false,
  },
  {
    id: "27",
    title: "Help the duck",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Help-The-Duck.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Help-The-Duck.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Help-The-Duck.mp4",
    link: "https://playinc.com/games/details/Help-The-Duck/129374840",
    isSubscribed: false,
  },
  {
    id: "28",
    title: "Jumpers quest",
    type: "PAID_GAME",
    category: "playinc",
    background:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Jumpers-Quest.png",
    icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Jumpers-Quest.png",
    video:
      "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Jumper_s-Quest.mp4",
    link: "https://playinc.com/games/details/Jumpers-Quest/133812290",
    isSubscribed: false,
  },

  // {
  //   id: "4",
  //   title: "",
  //   type: "CUSTOM_PAGE",
  //   category: "ca",
  //   background:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/gamearts/Cricket-Bash.png",
  //   icon: "https://assets.onmogaming.com/static/gaming-platform/Vodacom/home-feed/icons/Cricket-Bash.png",
  //   link: "https://vcsaca.onmogaming.com/play/975",
  //   video:
  //     "https://assets.onmostealth.com/static/gaming-platform/Vodacom/home-feed/videos/Cricket-Bash.mp4",
  // },
] as IHomeFeedItem[];

export const homeFeed = (JSON.parse(import.meta.env.VITE_HOME_FEED || "null") ||
  HOME_FEED) as IHomeFeedItem[];

export const getCategoryIcon = (category: string) => {
  switch (category) {
    case "challengesarena":
    case "ca":
      return {
        src1x: CaIcon1x,
        src2x: CaIcon2x,
        src3x: CaIcon3x,
      };
    case "gamegoza":
    case "onmo":
      return {
        src1x: OnmoIcon1x,
        src2x: OnmoIcon2x,
        src3x: OnmoIcon3x,
      };
    case "playinc":
      return {
        src1x: PlayIncIcon1x,
        src2x: PlayIncIcon2x,
        src3x: PlayIncIcon3x,
      };
    case "chessmasters":
    case "quizinc":
    case "stopclock":
    case "quizhead2head":
    case "unlock3":
    case "fanclash":
      return {
        src1x: FanclashIcon1x,
        src2x: FanclashIcon2x,
        src3x: FanclashIcon3x,
      };
  }
};

export const ESPORTS_FEED = {
  video:
    "https://assets.onmostealth.com/static/gaming-platform/Vodacom/esport/BLG_Intro.mp4",
  background:
    "https://assets.onmostealth.com/static/gaming-platform/Vodacom/esport/cover-image.webp",
};

export const ESPORTS_ICON_LIST = [
  {
    id: "fc",
    src1x: FcIcon1x,
    src2x: FcIcon2x,
    src3x: FcIcon3x,
  },
  {
    id: "sf5",
    src1x: Sf5Icon1x,
    src2x: Sf5Icon2x,
    src3x: Sf5Icon3x,
  },
  {
    id: "fortnite",
    src1x: FortniteIcon1x,
    src2x: FortniteIcon2x,
    src3x: FortniteIcon3x,
  },
  {
    id: "cod",
    src1x: CodIcon1x,
    src2x: CodIcon2x,
    src3x: CodIcon3x,
  },
  {
    id: "pubg",
    src1x: PubgIcon1x,
    src2x: PubgIcon2x,
    src3x: PubgIcon3x,
  },
];
